import { Injectable } from '@angular/core';
import { Observable, Observer } from 'rxjs';
import * as socketIo from 'socket.io-client';

const SERVER_URL = 'http://localhost:3000';

@Injectable({
  providedIn: 'root'
})
export class DispenserService {
  rate = 200;
  currentDischarge = { amount: 0 };
  currentObserver: Observer<any>;
  private isRunning = true;
  private socket;

  constructor() {
    /* // Inicializar la conexión del socket en el constructor
     this.socket = socketIo(SERVER_URL);

     // Manejo de eventos de errores en la conexión del socket
     this.socket.on('connect_error', (error: any) => {
       console.error('Error de conexión al servidor del dispensador', error);
       this.currentObserver.error(error);
       // Puedes implementar una lógica de reintentos aquí si es necesario
     });*/
  }

  startDischarge(maxAmount: number, automaticPumpCuttingTime?: number, rate?: number): Observable<any> {
    if (rate) {
      this.rate = rate as number;
    }
    this.currentDischarge = { amount: 0 };
    return Observable.create(
      (obs: Observer<any>) => {
        this.currentObserver = obs;
        this.socket = socketIo(SERVER_URL);
        if (automaticPumpCuttingTime) {
          const parameters = {};
          parameters['timeout'] = automaticPumpCuttingTime as number * 1000;
          this.socket.emit('contarPulsos', parameters);
        } else {
          this.socket.emit('contarPulsos');
        }
        this.socket.on('pulseRecieved', (data: any) => {
          if (data.pulses && typeof data.pulses === 'number') {
            this.currentDischarge.amount = (data.pulses / this.rate);
            obs.next(this.currentDischarge);
          }
          if (data.last) {
            if (data.mensaje === 'SECURITY_PULSES_COUNT_ABORTED') {
              const response = { message: 'SECURITY_PULSES_COUNT_ABORTED', code: 1 };
              console.error('error', response);
              this.currentObserver.error(response);
            } else {
              this.currentObserver.complete();
            }
            this.socket.close();
          }
          if (this.currentDischarge.amount >= maxAmount) {
            this.stopDischarge();
          }
        });
        this.socket.on('connect_error', (error: any) => {
          console.error('error', error);
          this.currentObserver.error(error);
          this.socket.close();
        });

      }
    );
  }

  stopDischarge() {
    return new Promise((resolve, reject) => {
      this.socket.emit('pararConteoPulsos', (result) => {
        if (result) {
          resolve(result);
        } else {
          reject(new Error('Error al parar el conteo de pulsos'));
        }
      });
    });
  }

  fakeStartDischarge(maxAmount: number, automaticPumpCuttingTime?: number, rate?: number): Observable<any> {
    if (rate) {
      this.rate = rate as number;
    }
    this.currentDischarge = { amount: 0 };
    return Observable.create(
      (obs: Observer<any>) => {
        this.currentObserver = obs;
        let numb = 1.55;
        setInterval(() => {
          if (this.isRunning) {
            numb = numb + 1.6;
            this.currentObserver.next({ amount: numb++ });
          }
        }, 1000);
      });

  }

  fakeStopDischarge() {
    console.log("desde fakeStopDischarge");
    this.isRunning = false;
  }
}
